module.exports = __webpack_public_path__ + "static/apple-touch-icon-eb8657c0292bf3f6d745e7e9c13fbd67.png";